import { IActions, store } from '../store';

const blacklist = ['auth.refreshToken'];

export const bindActions = (app: any) => {
  const actions: IActions = {};
  Object.keys(store.actions).forEach(scope => {
    actions[scope] = {};
    Object.keys(store.actions[scope]).forEach(action => {
      actions[scope][action] = async (...args: any[]) => {
        let result = store.actions[scope][action](app.state, ...args);
        const newState: any = {};
        const loading =
          typeof result.then === 'function' && !blacklist.includes([scope, action].join('.'));
        if (loading) {
          await new Promise(resolve => {
            app.setState((state: any) => {
              return { loader: { activeRequests: state.loader.activeRequests + 1 } };
            }, resolve);
          });
        }
        result = await result;
        await new Promise(resolve => {
          app.setState((state: any) => {
            Object.keys(result).forEach(key => {
              newState[key] = !Array.isArray(result[key])
                ? { ...state[key], ...result[key] }
                : result[key];
            });
            if (loading) {
              newState.loader = { activeRequests: state.loader.activeRequests - 1 };
            }
            return newState;
          }, resolve);
        });
        return newState;
      };
    });
  });
  return actions;
};
